import React from 'react';
import styled from 'styled-components';
import { Dialog as MuiDialog } from '@material-ui/core';

/**
 * Dialog는 배경 이미지와 함께 모달 형태로 보여지는 대화 상자입니다.
 *
 * @version 1.0.0
 * @author [chayeoi](https://github.com/chayeoi)
*/

const Dialog = styled(({ classes, ...otherProps }) => (
  <MuiDialog
    classes={{
      ...classes,
      paper: 'paper',
    }}
    {...otherProps}
  />
))`
  .paper {
    padding: 32px 40px;
  }
`;

/** @component */
export default Dialog;
